<template>
	<div class="flex xs-12 xs-wrap">
		<div class="flex xs-12 xs-wrap" v-if="benefits">
			<benefit-node
				v-for="(node, i) in benefits"
				:key="`${node.typeId}-${i}`"
				:node="node"
				@selected="$event => $emit('selected', $event)"
				@addChildBenefit="$event => $emit('addChildBenefit', $event)"
				@removeBenefit="$event => $emit('removeBenefit', $event)"
				@showUpdateNameModal="$event => $emit('showUpdateNameModal', $event)"
			/>
		</div>
	</div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon"
import JButton from "@/components/JButton/"
import BenefitNode from "./BenefitNode.vue"

export default {
	name: "benefit-tree",
	components: {
		BenefitNode,
		CrmIcon,
		JButton
	},
	props: {
		benefits: {
			type: Array
		},
		isLoading: {
			type: Boolean
		},
		selectedNode: {
			type: Object
		}
	},
	data: () => ({
		expanded: false
	})
}
</script>
